/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-24T16:43:12.826
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listConAttachmentTest,
	listConAttachmentTestInit,
	listConAttachmentTestByAuthorizations,
	deleteConAttachmentTest
	
} from '@api/storagemanage/ConAttachmentTest';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listConAttachmentTest({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConAttachmentTest(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listConAttachmentTestByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConAttachmentTestByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listConAttachmentTestInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConAttachmentTestInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteConAttachmentTest({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteConAttachmentTest({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
